export const AUTH_KEY = "AUTH";
